module.exports = __webpack_public_path__ + "img/caja_reporte.cb91acfb.png";